import InsuranceCompanies             from 'scripts/defa/insurance-companies/collection-insurance-companies';
import InsuranceCompany               from 'scripts/defa/insurance-companies/model-insurance-company';
import InsuranceCompanyCollectionView from 'scripts/defa/insurance-companies/view-insurance-company-collection-view';
import InsuranceCompanyContainer      from 'scripts/defa/insurance-companies/view-insurance-company-container';
import Module                         from 'scripts/module';

const InsuranceCompaniesModule = new Module('InsuranceCompaniesModule',{
	collections: {
		InsuranceCompanies
	},
	models     : {
		InsuranceCompany
	},
	views      : {
		InsuranceCompanyCollectionView,
		InsuranceCompanyContainer
	}
});
export default InsuranceCompaniesModule;